module.exports = __webpack_public_path__ + "5aeafd578571d59003122aed924b0d87.svg";